import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChartModule } from '@portal-core/ui/charts/components/chart/chart.module';
import { ProjectChecklistBarChartComponent } from './project-checklist-bar-chart.component';

@NgModule({
  declarations: [
    ProjectChecklistBarChartComponent
  ],
  imports: [
    ChartModule,
    CommonModule
  ],
  exports: [
    ProjectChecklistBarChartComponent
  ]
})
export class ProjectChecklistBarChartModule { }
